var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBodyMarkerArchive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a0df;}.cls-2{fill:#cfeaff;}.cls-3{fill:#fff;}.cls-4{fill:#71c2ea;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "body_marker_archive"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M502.15,600.39H87a57,57,0,0,1-57-57v-493a50,50,0,0,1,50-50H197.83A50,50,0,0,1,236,18l52.77,62.09a36.71,36.71,0,0,0,27.85,12.94l202.57.75a50,50,0,0,1,49.82,50l-.28,390A66.53,66.53,0,0,1,502.15,600.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 66,
    y: 135,
    width: 467,
    height: 398,
    rx: 50.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 67,
    y: 173,
    width: 467,
    height: 398,
    rx: 50
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M545.4,218H54.46a50.35,50.35,0,0,0-50.2,54.29L26.36,553.6A50.34,50.34,0,0,0,76.55,600h446a50.35,50.35,0,0,0,50.19-46.27l22.82-281.31A50.34,50.34,0,0,0,545.4,218Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M270.45,295.55h97.13a0,0,0,0,1,0,0v96.6a0,0,0,0,1,0,0H270.45A35.45,35.45,0,0,1,235,356.71V331a35.45,35.45,0,0,1,35.45-35.45Z",
    transform: "translate(645.14 42.56) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M292.35,532.42,174.73,429.1a12.24,12.24,0,0,1,8.09-21.44H418.05a12.24,12.24,0,0,1,8.09,21.44L308.52,532.42A12.26,12.26,0,0,1,292.35,532.42Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyMarkerArchive);
export default __webpack_public_path__ + "static/media/body_marker_archive.6d58d9518fe78632e98fdc9c78cfb486.svg";
export { ForwardRef as ReactComponent };